import atMentionsPluginTrigger from 'owa-editor-mentionsplugin/lib/utils/atMentionsPluginTrigger';
import createLazyPlugin from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "AtMentionsPlugin" */ './plugin/PickerPlugin');
});
export var LazyAtMentionsPickerPluginClass = createLazyPlugin(lazyModule, function (m) { return m.default; }, 'Picker', atMentionsPluginTrigger);
//# sourceMappingURL=index.js.map